import {
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Text,
} from '@chakra-ui/react';
import { TooltipProps } from './Tooltip.props';
import { FiHelpCircle } from 'react-icons/fi';
import React from 'react';

const InventoryTooltip: React.FC<TooltipProps> = React.memo((props) => {
  const { label, rightOffset } = props;
  return (
    <Popover trigger="click" placement="top">
      <PopoverTrigger>
        <Text
          as="span"
          position="absolute"
          top={['5px', '7px', '10px']}
          right={rightOffset}
          cursor="pointer"
          color="support.500"
          fontWeight={'bold'}>
          <FiHelpCircle size={15} />
        </Text>
      </PopoverTrigger>
      <PopoverContent bg="#d9e9d3" color="support.500" border="none">
        <PopoverArrow />
        <PopoverCloseButton />
        <PopoverBody padding={'4'}>{label}</PopoverBody>
      </PopoverContent>
    </Popover>
  );
});
export default InventoryTooltip;
